angular
    .module('festzelt-os.contacts')
    .factory('createDocumentForContacts', [
            'DocumentCreateService',
            (DocumentCreateService) => new CreateDocumentForRsvps(DocumentCreateService)
        ]
    );

class CreateDocumentForRsvps {
    constructor(DocumentCreateService) {
        this.documentCreateService = DocumentCreateService;

        this.key = 'create-document-for-contacts';
        this.title = 'Create document';
        this.level = 'selected';
    }

    action(action, store, newValue) {
        const dataForCreate = {
            ...store.getters.selectedFilters
        };

        if (_.get(store.state, 'vm.guestlist.id', null)) {
            dataForCreate.picklist_id = _.get(store.state, 'vm.guestlist.id', null);
        }

        this.documentCreateService.startNewDocumentWizard('contacts', store, dataForCreate);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/create-document-for-contacts.js